import React, { Component } from 'react';
import * as $ from 'jquery';
import { translate } from 'react-i18next';

class ConecctionsSearch extends Component {
  render() {
    const { t } = this.props;
    const cities = this.props.cities
    const business = this.props.business

    return (
      <div className="jumbotron panel-conecctions">
        <div className="row">
          <div className="col-md-12">
            <form method="post" onSubmit={this.props.handleConecctionsSearch}>
              {/* GETCITIES */}
              <fieldset>
                <div className="form-group">
                  <label htmlFor="event">
                    {t('dashboard.events.label_event')}
                  </label>
                  <input
                    className="form-control"
                    id="event"
                    onChange={this.props.handleConecctionsQueryChange}
                    placeholder={t('dashboard.events.holder_event')}
                    type="text"
                    value={this.props.ConecctionsQuery} />
                </div>
                <div className="form-group">
                  <label htmlFor="center">
                    {t('guest.benefits.city')}
                  </label>
                  <select
                    className="form-control"
                    id="city-select"
                    onChange={this.props.handleCityChange}
                    value={this.props.city}>
                    {cities.map((city, index) =>
                      (<option key={index} className="opcion-select" value={city.id}>{city.name}</option>)
                    )}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="center">
                    {t('guest.benefits.category')}
                  </label>
                  <select
                    className="form-control"
                    id="business-select"
                    onChange={this.props.handlebusinesChange}
                    value={this.props.busines}>
                    {business.map((business, index) =>
                      (<option key={index} className="opcion-select" value={business.id}>{business.name}</option>)
                    )}
                  </select>
                </div>
                <div className="form-group">
                  <button
                    className="btn btn-primary btn-search-conecctions"
                    disabled={this.props.isSearching}
                    type="submit">
                    {t('dashboard.events.btn_search')}
                  </button>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

export default translate('common')(ConecctionsSearch);


// WEBPACK FOOTER //
// ./src/dashboard/conecctions/ConecctionsSearch.js